import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import HotRecommend from "./components/HotRecommend";
import CategoryNav from "./components/CategoryNav";
import LatestUpdate from "./components/LatestUpdate";
import FAQSection from "./components/FAQSection";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "玫瑰视频",
      url: "https://meiguishipin.com",
      description: "玫瑰视频汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，高清免费在线观看。",
    },
    {
      "@type": "WebSite",
      name: "玫瑰视频",
      url: "https://meiguishipin.com",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://meiguishipin.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      name: "玫瑰视频 - 首页",
      url: "https://meiguishipin.com/",
      description: "玫瑰视频📢汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，高清免费在线观看不缓冲。",
      isPartOf: { "@type": "WebSite", name: "玫瑰视频", url: "https://meiguishipin.com" },
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "玫瑰视频是什么？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "玫瑰视频是一个汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源的在线平台，提供高清免费在线观看服务。",
          },
        },
        {
          "@type": "Question",
          name: "玫瑰视频需要付费吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "不需要！玫瑰视频上的所有影视资源均免费在线观看，无需注册，无需付费。",
          },
        },
        {
          "@type": "Question",
          name: "支持哪些设备观看？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "玫瑰视频支持在电脑、平板、手机等多种设备上观看，打开浏览器即可流畅观看。",
          },
        },
        {
          "@type": "Question",
          name: "影视资源更新频率如何？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "我们每日更新大量影视资源，通常新剧集上线后24小时内即可在平台观看。",
          },
        },
        {
          "@type": "Question",
          name: "视频画质怎么样？有缓冲吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "玫瑰视频所有资源均提供高清画质（720P/1080P），采用CDN加速技术确保播放流畅不缓冲。",
          },
        },
        {
          "@type": "Question",
          name: "香蕉视频、糖豆视频、小蓝视频、蓝莓视频有什么区别？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "四个平台各有特色——香蕉视频主打电视剧，糖豆视频侧重电影，小蓝视频以综艺动漫见长，蓝莓视频拥有丰富的纪录片和少儿内容。",
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <SEO
        title="玫瑰视频 | 香蕉视频与糖豆视频高清在线观看 | 小蓝视频蓝莓视频免费电视剧全集"
        description="玫瑰视频📢汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，高清免费在线观看不缓冲，🎬海量电视剧全集和电影大全每日更新，满足各类追剧需求。"
        keywords="玫瑰视频,香蕉视频,糖豆视频,小蓝视频,蓝莓视频,高清在线观看,免费电视剧全集,电影大全,不缓冲,最新影视"
        canonicalUrl="https://meiguishipin.com/"
      />

      <Navbar />

      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryNav />
        <LatestUpdate />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}